/**
 * listPasskeys management call (Req 11.4)
 *
 * `GET /auth/passkey/credentials` を ApiClient 経由で発行し、shim wire envelope
 * `{ credentials: PasskeySummary[] }` (design.md §API Contract 910 行) から
 * `credentials` 配列を取出して返す。
 * ApiClient が HTTP error を `AuthError` として surface するため、ここでは再ラップしない。
 */
/**
 * 登録済み passkey の一覧を返す (機微素材を含まないサマリ)。
 *
 * @param apiClient `@auth/client` の ApiClient (inject 経由)
 */
export async function listPasskeys(apiClient) {
    const response = await apiClient.get("/auth/passkey/credentials");
    return response.credentials;
}
//# sourceMappingURL=list-passkeys.js.map